import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// To use the plugin variables inside a template use the following structure: {{ $t(" ") }}
// To use the plugin variables inside our javascript use the following structure i18n.t(' ') and make sure you are importing i18n in the component import i18n from '@/i18n' also most of the times the variable would need to be inside a computed fucntion to be reactive

function loadLocaleMessages () {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getLocale (appName) {
  if (appName === 'Heise') {
    return 'de'
  } else {
    return process.env.VUE_APP_I18N_LOCALE || 'en'
  }
}

export default new VueI18n({
  locale: getLocale(process.env.APP_NAME),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
